import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useAppSelector } from "../../../../../../../../hooks/store-hooks";
import { useListaCidadesService } from "../../../../../../../../../use-cases/geo-veles";
import { useState } from "react";

export const EditCidade = (props: {
  openEditCidade: boolean;
  oldCidade: string;
}) => {
  // State
  const { listaCidades } = useAppSelector((state) => state);
  // Use State
  const [newCidade, setNewCidade] = useState<string>(props.oldCidade);
  // Hook
  const { openEditListaCidade, setEditListaCidadesFields } =
    useListaCidadesService();

  const handleClose = () => {
    openEditListaCidade(false);
  };

  return (
    <>
      {props.openEditCidade === true && (
        <Dialog
          open={listaCidades.openEditCidades}
          onClose={handleClose}
          hideBackdrop
        >
          <DialogTitle>Editar Cidade</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Digite abaixo o novo nome da cidade atualizado.
            </DialogContentText>
            <Box mt={3}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                autoFocus
                value={newCidade}
                margin="dense"
                label="Digite o novo nome da cidade"
                type="text"
                fullWidth
                variant="standard"
                onChange={(e) => {
                  setNewCidade(e.target.value);
                }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button
              autoFocus
              onClick={() => {
                handleClose();
                // setEditListaCidadesFields({
                //     listaCidades: listaCidades.editListaCidadesForm
                // })
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
